'use client';

import { IconButton, Tooltip } from '@coolblue-development/freddy';
import { Copy } from '@coolblue-development/icons';
import { useEffect, useState } from 'react';

type Props = {
  contentToCopy: string;
  tooltipDescription: string;
};

export const CopyButton = ({ contentToCopy, tooltipDescription }: Props) => {
  const [open, setOpen] = useState(false);
  const [mounted, setMounted] = useState(false);
  const tooltipId = 'tooltip-copy-button';

  useEffect(() => {
    // This is needed to prevent the tooltip from being rendered on the server which causes a hydration error in Cypress.
    // Todo: Remove when the issue is fixed in the tooltip component.
    setMounted(true);
  }, []);

  useEffect(() => {
    // Set tooltop position. This is not possible to overwrite in the tooltip component
    document.getElementById(tooltipId)?.style.setProperty('top', '1.8rem');
  }, [mounted]);

  return mounted ? (
    <Tooltip description={tooltipDescription} open={open} id={tooltipId} placement='right'>
      <IconButton
        iconColor='inverse'
        sx={{ padding: 0 }}
        onClick={() => {
          navigator.clipboard.writeText(contentToCopy);
          setOpen(true);
          setTimeout(() => {
            setOpen(false);
          }, 2000);
        }}
        aria-label='Copy email address'
      >
        <Copy />
      </IconButton>
    </Tooltip>
  ) : null;
};
